import { getLocale } from "../runtime";

const sv_discountcodeapplied = /** @type {(inputs: {code: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Rabattkod ${inputs.code}`
};

const discountcodeapplied = /** @type {(inputs: {code: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_discountcodeapplied(inputs)
	return "discountCodeApplied";
};

export { discountcodeapplied as "discountCodeApplied" };